import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import { MenuIdCustomerExperiences } from '@jira/navigation-apps__constants/src/MenuIdCustomerExperiences.tsx';
import { SidebarIdCsmApp } from '@jira/navigation-apps__constants/src/SidebarIdCsmApp.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getCustomerServiceL1NavigationResources } from '@jira/router-resources__customer-service-l1-navigation/src/getCustomerServiceL1NavigationResources.tsx';
import { csmProjectCustomerNotificationsRuleRoute } from '@jira/router-routes__help-center-settings-routes/src/csmProjectCustomerNotificationsRuleRoute.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';

import { getCsmExperiencesResources } from './getCsmExperiencesResources.tsx';
import { helpCenterSettingsCustomerNotificationsAppPageEntryPoint } from './ui/customer-notifications/index.tsx';

export const csmProjectCustomerNotificationsRuleRouteEntry: Route = createEntry(
	csmProjectCustomerNotificationsRuleRoute,
	() => ({
		group: 'helpcenter-settings',
		perfMetricKey: 'help-center-settings.csm-project-customer-notifications-rule',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MenuIdCustomerExperiences,
			sidebarId: SidebarIdCsmApp,
		},
		entryPoint() {
			return fg('csm_appification_standalone_navigation')
				? helpCenterSettingsCustomerNotificationsAppPageEntryPoint
				: notFoundPageEntrypoint;
		},
		resources: [...getCustomerServiceL1NavigationResources(), ...getCsmExperiencesResources()],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
